export default __webpack_public_path__ + "static/media/box.c2c38ca8.png";